import React from 'react'
import { ProcessEditPage } from '@rankmi/ats-app'

const ProcessPublishSteps = ({ processId }) => {

  return (
    <ProcessEditPage
      processId={processId}
      connectionsDocumentationUrl='https://rankmi.odoo.com/knowledge/article/2503'
      tagsDocumentationUrl='https://rankmi.odoo.com/knowledge/article/2526'
    />
  )
}

export default ProcessPublishSteps